<template>
  <div class="header">
    <span class="title">{{title}}</span>
    <span class="time">{{ time?'数据时间：'+time:'' }}</span>
  </div>
</template>

<script>
export default {
  props: {
    time: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="less" scoped>
.header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 2.08vw;
  box-sizing: border-box;
  margin: 0.68vw 0vw 0vw 1.25vw;
  border-top-left-radius: 30px;
  background: linear-gradient(262deg, rgba(255, 255, 255, 0) 0%, rgba(70, 148, 248, 0.23) 100%);
  .title {
    height: 2.08vw;
    box-sizing: border-box;
    display: inline-block;
    color: white;
    padding: 0vw 0.42vw;
    line-height: 2.08vw;
    border-radius: 0.26vw;
    background: #2D74F5;
    transform: skew(-14deg);
    }
    .time{
      padding-right: 1.09vw;
      font-size: 0.73vw;
      font-weight: 400;
      color: #666666;
      line-height: 1.04vw;
    }
}

.risk_control_dark .header .time{
  color: #FFF;
}
</style>
